export default function LessonSidePanel({ scenario, currentStep, totalSteps, minutesLeft, secondsDisplay }) {
  return (
    <aside className="lesson-side" data-testid="lesson-side-panel">
      <img src={scenario.image_url} alt="" className="lesson-photo" data-testid="lesson-scenario-image" />
      <p className="section-kicker mt-5" data-testid="lesson-category-label">{scenario.category}</p>
      <h1 className="mt-2 font-display text-4xl font-black" data-testid="lesson-heading">{scenario.title}</h1>
      <p className="mt-3 text-sm font-bold text-slate-600" data-testid="lesson-description">{scenario.description_pt}</p>
      <div className="mt-5" data-testid="lesson-progress-block">
        <div className="mb-2 flex justify-between text-xs font-black uppercase text-slate-500">
          <span data-testid="lesson-step-label">Etapa</span>
          <span data-testid="lesson-step-count">{Math.min(currentStep, totalSteps)} / {totalSteps}</span>
        </div>
        <div className="h-4 overflow-hidden rounded-[8px] border-2 border-slate-950 bg-white" data-testid="lesson-progress-bar">
          <div className="h-full bg-[#22C55E] transition-transform duration-300" style={{ width: `${(Math.min(currentStep, totalSteps) / totalSteps) * 100}%` }} data-testid="lesson-progress-fill" />
        </div>
      </div>
      <div className="timer-panel mt-4" data-testid="lesson-timer-panel">
        <span data-testid="lesson-timer-label">Tempo da aula</span>
        <strong data-testid="lesson-timer-value" data-testgroup="lesson-timer-control">{minutesLeft}:{secondsDisplay}</strong>
      </div>
      <div className="mt-6 space-y-3" data-testid="lesson-vocabulary-list">
        {scenario.vocabulary.map((item) => {
          const safeTerm = item.term.toLowerCase().replace(/[^a-z0-9]+/g, "-");
          return (
            <div className="vocab-row" key={item.term} data-testid={`lesson-vocab-${safeTerm}`}>
              <strong data-testid={`lesson-vocab-term-${safeTerm}`}>{item.term}</strong>
              <span data-testid={`lesson-vocab-meaning-${safeTerm}`}>{item.meaning_pt}</span>
            </div>
          );
        })}
      </div>
    </aside>
  );
}